import { WebRule } from "types/web-rule";

export class ExperienceActivity {
    id: number;
    sectionId: number;
    sectionName: string;
    sortOrder: number;
    timeSets: WebRule[];

    constructor(values?: Partial<ExperienceActivity>) {
        this.id = values?.id ?? 0;
        this.sectionId = values?.sectionId ?? 0;
        this.sectionName = values?.sectionName ?? "";
        this.sortOrder = values?.sortOrder ?? 0;
        this.timeSets = values?.timeSets?.map((rule) => new WebRule(rule)) ?? [];
    }

    clone(): ExperienceActivity {
        return new ExperienceActivity(this);
    }
}
